import io from "socket.io-client";

let socket;

let lastId = 0;
const listeners = []; // {id: <lastId+1>, name, callback}
let timeoutCounter = 0;

const emitACK = (name, data) => {
    if (socket) {
        let newData;
        if (name === "dataset.edit" && data && data.data && data.data.socket_id !== socket.io.engine.id) {
            // if (data.data && data.data.socket_id !== socket.io.engine.id) {
            newData = {
                ...data,
                data: {
                    ...data.data,
                    socket_id: socket.io.engine.id,
                },
            };
            // }
        } else if (name.includes("dataset") && data && data.socket_id !== socket.io.engine.id) {
            // if (data.socket_id !== socket.io.engine.id) {
            newData = {
                ...data,
                socket_id: socket.io.engine.id,
            };
            // }
        } else {
            newData = data;
        }

        // console.log(name, newData);
        socket.timeout(5000).emit(name, newData, (err) => {
            if (err) {
                timeoutCounter++;
                console.error(`[${timeoutCounter}] socket.js emitACK timeout on event:${name}`, newData, socket.io.engine.id);
                emitACK(name, newData);
            } else if (timeoutCounter > 0) {
                timeoutCounter = 0;
            }
        });
    }
};

const exports = {
    connect: (baseUrl, authToken, authRefreshToken, callback) => {
        socket = io(`${baseUrl}/users`, {
            query: `token=${authToken}&refresh_token=${authRefreshToken}&client=react`,
        });

        socket.on("connect", () => {
            callback(socket.io.engine.id);
        });

        socket.io.on("error", (error) => {
            console.error("socket.io error", error);
        });

        socket.io.on("reconnect", (error) => {
            console.error("socket.io reconnect", error);
        });

        socket.io.on("reconnect_attempt", (error) => {
            console.error("socket.io reconnect_attempt", error);
        });

        socket.io.on("reconnect_error", (error) => {
            console.error("socket.io reconnect_error", error);
        });

        socket.io.on("reconnect_failed", (error) => {
            console.error("socket.io reconnect_error", error);
        });

        socket.io.on("ping", () => {
            // console.info("socket.io ping", new Date());
        });

        socket.on("disconnect", (reason) => {
            console.error("socket.io disconnect", reason);
        });

        socket.on("connect_error", (error) => {
            console.error("socket.io connect_error", error);
        });

        // socket.onAny((event) => {
        //     console.log(`socket.io onAny ${event}`);
        // });
    },
    updateTokens: (authToken, authRefreshToken) => {
        socket.io.opts.query = {
            token: authToken,
            refresh_token: authRefreshToken,
            client: "react",
        };
    },
    disconnect: (callback) => {
        if (socket) {
            listeners.length = 0;
            socket.removeAllListeners();
            socket.close();
            socket = undefined;
        }

        if (callback) callback();
    },
    emit: (name, data) => {
        if (socket) {
            socket.emit(name, data);
        }
    },
    emitACK,
    on: (name, callback, reset = false) => {
        if (socket) {
            if (reset) {
                const listenerIndex = listeners.findIndex((listener) => listener.name === name);
                const listener = listeners[listenerIndex];

                if (listener) {
                    socket.off(listener.name, listener.callback);
                    listeners.splice(listenerIndex, 1);
                }
            }
            lastId++;

            const listener = {
                id: lastId,
                name,
                callback,
            };

            listeners.push(listener);

            socket.on(listener.name, listener.callback);

            return lastId;
        }

        return undefined;
    },
    once: (name, callback) => {
        if (socket) {
            socket.once(name, callback);
        }
    },
    removeListener: (id) => {
        if (socket) {
            const listenerIndex = listeners.findIndex((listener) => listener.id === id);
            const listener = listeners[listenerIndex];

            if (listener) {
                socket.off(listener.name, listener.callback);
                listeners.splice(listenerIndex, 1);
            }
        }
    },
};

export default exports;
